import { createApplicationFormSelector } from './createApplicationFormSelector';

export const selectFioWasChanged = (state) => createApplicationFormSelector(state, 'fio_was_change');
